module.exports = __webpack_public_path__ + "static/media/home-farms.ea87ff43.jpg";